import { api } from './api';
import { 
  Video, 
  AudioFeatures,
  PaginatedResponse 
} from '@meradio/shared-types';

export interface VideoWithMetadata extends Video {
  isLiked?: boolean;
  audioFeatures?: AudioFeatures | null;
}

export interface GetVideosParams {
  limit?: number;
  offset?: number;
  channelId?: string;
  sortBy?: 'recent' | 'oldest' | 'title';
}

export const getVideos = async (params: GetVideosParams = {}): Promise<PaginatedResponse<VideoWithMetadata>> => {
  const {
    limit = 50,
    offset = 0,
    channelId,
    sortBy = 'recent'
  } = params;

  const queryParams: Record<string, any> = {
    limit,
    offset,
    sortBy
  };

  if (channelId) {
    queryParams.channelId = channelId;
  }

  const response = await api.get<VideoWithMetadata[]>('/videos', {
    params: queryParams
  });
  
  if (!response.success) {
    throw new Error(response.error || 'Failed to get videos');
  }
  
  return response as PaginatedResponse<VideoWithMetadata>;
};

export const getVideo = async (videoId: string): Promise<VideoWithMetadata> => {
  if (!videoId || videoId.trim().length === 0) {
    throw new Error('Video ID is required');
  }

  const response = await api.get<VideoWithMetadata>(`/videos/${videoId}`);
  
  if (!response.success || !response.data) {
    throw new Error(response.error || 'Failed to get video');
  }
  
  return response.data;
};

export interface GetVideosByChannelParams {
  channelId: string;
  limit?: number;
  offset?: number;
}

export const getVideosByChannel = async (params: GetVideosByChannelParams): Promise<PaginatedResponse<VideoWithMetadata>> => {
  const { channelId, limit = 50, offset = 0 } = params;

  if (!channelId || channelId.trim().length === 0) {
    throw new Error('Channel ID is required');
  }

  const response = await api.get<VideoWithMetadata[]>(`/videos/channel/${channelId}`, {
    params: { limit, offset }
  });
  
  if (!response.success) {
    throw new Error(response.error || 'Failed to get videos by channel');
  }
  
  return response as PaginatedResponse<VideoWithMetadata>;
};

